import { Input } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import styled from 'styled-components';

export const InputStyled = styled(Input)`
  background-color: #FFFFFF ;
  border-radius: 2px;
  color: #828282;
  border: 1px solid #B2BBBF;
  min-width: 0;
  outline: none;
  &:focus {
    background: #FFFFFF;
    border: 1px solid #000000;
    color: #000000;
    &:hover {
    background: #FFFFFF;
    border: 1px solid #000000;
  }
  }
  &:hover {
    background: #FFFFFF;
    border: 1px solid #B2BBBF;
  }
`;

export const InputStyledMasked = styled(MaskedInput)`
  background-color: #FFFFFF ;
  border-radius: 2px;
  color: #828282;
  border: 1px solid #B2BBBF;
  min-width: 0;
  outline: none;
  &:focus {
    background: #FFFFFF;
    border: 1px solid #000000;
    color: #000000;
    &:hover {
    background: #FFFFFF;
    border: 1px solid #000000;
  }
  }
  &:hover {
    background: #FFFFFF;
    border: 1px solid #B2BBBF;
  }
`;

export const DivItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DivButtons = styled(DivItems)`
  display: flex;
  float: right;
  gap: 15px;
`;

export const ButtonCancelar = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 96px;
  height: 32px;
  background: #fff;
  color: #24a95d;
  border: 1px solid #24a95d;
  border-radius: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
`;

export const ButtonSalvar = styled(ButtonCancelar)`
  border: none;
  color: #fff;
  background: #24a95d;
`;
